<template>
    <div class="font-semibold text-lg text-skin-b-list-mute bg-skin-b-list-head 
                w-full px-3 py-2 rounded-lg border-2 border-skin-b-list-bord">
        <slot></slot>
    </div>
</template>